import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosApiInstance } from "@/lib/axios";
import { API_PORTAL_URL } from "@/lib/config";

export const getHomeDetails = createAsyncThunk(
  "Activity/HomePageList",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_PORTAL_URL}/Activity/HomePageList`,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Home:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllCMSByURL = createAsyncThunk(
  "CMS/FindByURLCMS",
  async (URL: string) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/CMS/FindByURLCMS`,
        { CMSURL: URL },
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Page Details:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllMetaData = createAsyncThunk(
  "SeoTags/FindAllActiveSeoTags",
  async (FormData: any) => {
    try {
      const response = await axiosApiInstance.get(
        `${API_PORTAL_URL}/SeoTags/FindAllActiveSeoTags`,
        FormData,
      );
      return response.data?.Data
        ? response.data?.Data?.find(
            (meta: any) => meta?.PageUrl === FormData?.PageURL,
          )
        : {};
    } catch (error: any) {
      console.error("Error Fetching Meta Data:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllActiveSettings = createAsyncThunk(
  "Setting/FindAllActiveSetting",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_PORTAL_URL}/Setting/FindAllActiveSetting`,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Setting:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllActiveBanner = createAsyncThunk(
  "Banner/FindAllActiveBanner",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_PORTAL_URL}/Banner/FindAllActiveBanner`,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Banner:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const insertInquiry = createAsyncThunk(
  "Inquiry/InsertInquiry",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Inquiry/InsertInquiry`,
        formdata,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error inserting inquiry:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllActiveGallerys = createAsyncThunk(
  "Gallery/FindAllActiveGallery",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_PORTAL_URL}/Gallery/FindAllActiveGallery`,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Gallery images:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllActiveRooms = createAsyncThunk(
  "Room/FindAllActiveRoom",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_PORTAL_URL}/Room/FindAllActiveRoom`,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Rooms:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllActiveTestimonials = createAsyncThunk(
  "Testimonial/FindAllActiveTestimonial",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_PORTAL_URL}/Testimonial/FindAllActiveTestimonial`,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Testimonials:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllActiveAmenities = createAsyncThunk(
  "Amenities/FindAllActiveAmenities",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_PORTAL_URL}/Amenities/FindAllActiveAmenities`,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Amenities:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
